import { createAsyncThunk } from '@reduxjs/toolkit'
import * as service from './InfoCenter.services'
import { paginationData } from '../Pagination/reducers'
import { toast } from 'react-toastify'

//
export const InfoCenterDocumentCategoryList = createAsyncThunk(
    'InfoCenter/Category/listing',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.InfoCenterDocumentCategoryListApi(data)

            const limit = data.params._limit || 10
            const TotalPage = Math.ceil(res.totalRecords / limit) || 1
            const finalRes = {
                data: res.data,
                page: data.params._page,
                totalPage: TotalPage,
                totalRecords: res?.totalRecords
            }
            return finalRes
        } catch (err) {
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)

///
export const InfoCenterDocumentSubCategoryList = createAsyncThunk(
    'InfoCenter/SubCategory/listing',
    async (data, { rejectWithValue }) => {
        try {
            const res = await service.InfoCenterDocumentSubCategoryListApi(data)

            const limit = data.params._limit || 10
            const TotalPage = Math.ceil(res.totalRecords / limit) || 1
            const finalRes = {
                data: res.data,
                page: data.params._page,
                totalPage: TotalPage,
                totalRecords: res?.totalRecords
            }
            return finalRes
        } catch (err) {
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)

//
export const DocumentList = createAsyncThunk(
    'InfoCenter/document/listing',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const res = await service.DocumentListApi(data)

            if (data.params._limit) {
                // Pagination Section
                const limit = data.params._limit || 10
                const TotalPage = Math.ceil(res.totalRecords / limit) || 1
                const paginationObj = {
                    page: data.params._page,
                    totalPage: TotalPage,
                    totalRecords: res?.totalRecords
                }
                dispatch(paginationData(paginationObj))
            }

            return res
        } catch (err) {
            if (data.params._limit) {
                const TotalPage = 1
                const paginationObj = {
                    page: 1,
                    totalPage: TotalPage,
                    totalRecords: 1
                }
                dispatch(paginationData(paginationObj))
            }
            if (!err.response) {
                throw err
            }
            toast.error(err.response.data)

            return rejectWithValue(err.response.data)
        }
    }
)